/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientResponseLanguageInner
 */
export interface PccPatientResponseLanguageInner {
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponseLanguageInner
     */
    languageDesc?: string;
}

/**
 * Check if a given object implements the PccPatientResponseLanguageInner interface.
 */
export function instanceOfPccPatientResponseLanguageInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PccPatientResponseLanguageInnerFromJSON(json: any): PccPatientResponseLanguageInner {
    return PccPatientResponseLanguageInnerFromJSONTyped(json, false);
}

export function PccPatientResponseLanguageInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientResponseLanguageInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'languageDesc': !exists(json, 'languageDesc') ? undefined : json['languageDesc'],
    };
}

export function PccPatientResponseLanguageInnerToJSON(value?: PccPatientResponseLanguageInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'languageDesc': value.languageDesc,
    };
}

